const MAP = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-600 border-slate-300" },
  sent: { label: "Sent", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  partial: { label: "Part paid", cls: "bg-amber-50 text-amber-700 border-amber-300" },
  paid: { label: "Paid", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  overdue: { label: "Overdue", cls: "bg-red-50 text-red-700 border-red-200" },
  cancelled: { label: "Cancelled", cls: "bg-slate-50 text-slate-400 border-slate-200 line-through" },
  written_off: { label: "Written off", cls: "bg-slate-800 text-slate-100 border-slate-800" },
};

export const StatusBadge = ({ status, testId }) => {
  const entry = MAP[status] || MAP.draft;
  return (
    <span
      data-testid={testId || `invoice-status-${status}`}
      className={`inline-flex items-center border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.12em] ${entry.cls}`}
    >
      {entry.label}
    </span>
  );
};
